import request from '@/utils/request'

export function deleteFee(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.deleteFee',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg || '删除费用失败')
      }
    }).catch(error => {
      reject(error)
    })
  })
}